// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","tile":"j_rnr","buttonPlayPause":"_2SvFe","gifPlaying":"_1QRwL"};